export default __webpack_public_path__ + "static/media/logo-on-top.ebed34ea.svg";